export default "__VITE_ASSET__d53f294a__"